import { Highlight } from '@seek/ai-elements';
import { useTranslations } from '@vocab/react';
import {
  Box,
  ButtonIcon,
  Divider,
  Heading,
  IconAI,
  IconClear,
  Stack,
} from 'braid-design-system';
import type { ComponentProps } from 'react';
import { RemoveScroll } from 'react-remove-scroll';

import translations from '../.vocab';
import { useCareerFeedAIAssistant } from '../hooks/useCareerFeedAIAssistant';

import * as styles from './CareerFeedMobileModal.css';

export const CareerFeedMobileModal = ({
  children,
}: {
  children: ComponentProps<typeof Stack>['children'];
}) => {
  const { t } = useTranslations(translations);

  const { closeMobileModal, isMobileWindowClosed } = useCareerFeedAIAssistant();

  if (isMobileWindowClosed) {
    return null;
  }

  return (
    <Box className={styles.container} zIndex="modal" role="dialog">
      <Box
        height="full"
        width="full"
        display="flex"
        justifyContent="flexStart"
        paddingY="large"
        paddingX="medium"
      >
        <Stack space="medium">
          <Box display="flex" justifyContent="spaceBetween" alignItems="center">
            <Heading level="4" icon={<IconAI tone="brandAccent" />}>
              <Highlight>{t('Define your preferences')}</Highlight>
            </Heading>

            <ButtonIcon
              icon={<IconClear />}
              label={t('Close')}
              id="close-modal-genai"
              size="standard"
              onClick={() => {
                closeMobileModal();
              }}
            />
          </Box>
          <Divider />
          <Box height="full" display="flex" style={{ maxHeight: '100%' }}>
            <RemoveScroll enabled={isMobileWindowClosed}>
              {children}
            </RemoveScroll>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
